import React from 'react';
import {FormGroup} from 'reactstrap';
import {reduxForm, Field} from 'redux-form';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {renderField} from '../fields/renderField';
import {saveContact} from '../../actions/index';

class ContactForm extends React.Component{
  onSubmit = formProps => {
    const {saveContact} = this.props;
    saveContact(formProps).then(({payload}) => {
      if(payload.status !== 200){
        alert('ระบบ internet มีปัญหา กรุณาลองอีกครั้ง หรือติดต่อด้วยช่องทางอื่น');
        return;
      }
      if(payload.data.success === false){
        alert(payload.data.errorMessage);
        return;
      }
      alert('ได้รับข้อความแล้ว จะรีบติดต่อกลับไปนะครับ');
      this.props.reset('contactForm');
    });
  }
  render(){
    const {handleSubmit} = this.props;
    return (
      <div className="box-border p-4 mb-4">
        <h2 className="text-center mb-4">ส่งข้อความหาเรา</h2>
        <form name="contactForm" onSubmit={handleSubmit(this.onSubmit)}>
          <div className="row">
            <div className="col-sm-6 col-md-12 col-lg-6">
              <FormGroup>
                <Field type="text" id="contactName" name="name" placeholder="ชื่อผู้ติดต่อ *"  component={renderField} />
              </FormGroup>
            </div>
            <div className="col-sm-6 col-md-12 col-lg-6">
              <FormGroup>
                <Field type="text" id="contactInfo" name="info" placeholder="เบอร์โทร/อีเมล *"  component={renderField} />
              </FormGroup>
            </div>
          </div>
          <FormGroup>
            <Field type="text" id="contactSubject" name="subject" placeholder="ติดต่อเรื่อง *"  component={renderField} />
          </FormGroup>
          <FormGroup>
            <Field type="textarea" id="contactMessage" name="message" placeholder="รายละเอียด *"  component={renderField} />
          </FormGroup>
          <button type="submit" className="btn btn-submit">ส่งข้อความ</button>
        </form>
      </div>
    );
  }
};
export default compose(
  connect(null, {saveContact}),
  reduxForm({form:'contact'})
)(ContactForm);


// WEBPACK FOOTER //
// ./src/components/contact/ContactForm.js